import React from 'react';
import { useIntl } from 'react-intl';

import AiIcon from '../AiIcon';

const TableEmpty = () => {
  const intl = useIntl();

  return (
    <div className="table-empty">
      <AiIcon name="empty" />
      <div className="table-empty__text">
        {' '}
        {intl.formatMessage({
          id: 'result.empty',
        })}
      </div>
    </div>
  );
};

export default TableEmpty;
